import AbsenceSummaryInformationBox from '@web/labor/AbsenceSummaryInformationBox/AbsenceSummaryInformationBox';

export default {
  ReactComponent: AbsenceSummaryInformationBox,
  bindings: {
    summary: '<',
  },
};
